import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import roc360 from "../../../assets/roc360.png"
import { InternalValuationReviewStore } from "../../../stores/internalValuationReviewStore";
import { observer } from "mobx-react";
import { getFullAddress } from "../../../utils/utils";
import { SubjectPropertyBox } from "../subjectPropertyBox";
import { CurrentPropertyStatusBox } from "../currentPropertyStatusBox";
import { SubjectNeighborhoodInfoBox } from "../subjectNeighborhoodInfoBox";
import { AdverseExternalFactorsBox } from "../adverseExternalFactorsBox";
import { ReportHeader } from "../reportHeader";

const useStyles = makeStyles(() => ({
  page: {
    fontFamily: "Roboto, Arial, sans-serif",
    border: "1px solid lightgray",
    borderRadius: "5px",
    width: "1018px",
    height: "1440px",
    padding: "64px 40px 64px 40px",
  },
  header: {
    marginRight: "40px",
    marginBottom: "20px",
  },
  lenderLogo: {
    width: "232px",
    height: "114px",
  },
  valuationTitle: {
    fontSize: "inherit",
    color: "#1C3F78",
    lineHeight: "1",
    fontWeight: 100,
  },
  reportTitle: {
    fontSize: "inherit",
    color: "#2EC2C9",
    lineHeight: "1",
    fontWeight: "bolder",
  },
}));

interface Page1Props {
  internalValuationReviewStore: InternalValuationReviewStore;
}

export const Page1 = observer(({ internalValuationReviewStore }: Page1Props) => {
  const classes = useStyles();

  const internalValuationData = internalValuationReviewStore.initialData;
  const internalValuationReview = internalValuationData.internalValuationReview;

  const address = internalValuationReviewStore.initialData.propertyFullAddress; //getFullAddress(internalValuationReview);

  const propertyStatusInformation = internalValuationReviewStore.getPropertyStatusInformation();
  const neighborhoodHousingConditions = internalValuationReviewStore.getNeighborhoodHousingConditions();

  //when the server sent the photos (data URIs) only those are used, a photo it could not get shows the placeholder instead of a blank
  const { reportImages } = internalValuationReviewStore;
  //(without them the uploaded photo, when there is one, wins over the DS ones)
  const recommendedImage = reportImages
    ? reportImages.subjectImage
    : (internalValuationReviewStore.uploadedSubjectImageUrl || internalValuationReviewStore.subjectCoverImageUrl);

  return (
    <div className={classes.page}>
      <header className={classes.header}>
        <ReportHeader
          logoImg={<img src={roc360} alt="Roc 360 Logo" className={classes.lenderLogo} />}
          valuationTitleClassName={classes.valuationTitle}
          reportTitleClassName={classes.reportTitle} />
      </header>
      <main>
        <Grid container spacing={2}>
          <Grid item>
            <SubjectPropertyBox recommendedImage={recommendedImage} address={address} internalValuationReview={internalValuationReview} />
          </Grid>
          <Grid item xs={12}>
            <CurrentPropertyStatusBox propertyStatusInformation={propertyStatusInformation} />
          </Grid>
          <Grid item xs={12}>
            <SubjectNeighborhoodInfoBox internalValuationReview={internalValuationReview} neighborhoodHousingConditions={neighborhoodHousingConditions} />
          </Grid>
          <Grid item xs={12}>
            <AdverseExternalFactorsBox adverseFactorsComments={internalValuationReview.adverseFactorsComments} />
          </Grid>
        </Grid>
      </main>
    </div>
  );
});